/**
 * @generated SignedSource<<b9436f11fc36ada4ae968dac488bbb0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetCalendarOverviewContentPaginatedQuery$variables = {
  after?: string | null;
  first?: number | null;
  id: string;
};
export type WidgetCalendarOverviewContentPaginatedQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendarOverviewContent_widget">;
  } | null;
};
export type WidgetCalendarOverviewContentPaginatedQuery = {
  response: WidgetCalendarOverviewContentPaginatedQuery$data;
  variables: WidgetCalendarOverviewContentPaginatedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v6 = [
  (v5/*: any*/)
],
v7 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "DEFAULT"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
  }
],
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "WEEKDAY_AND_DATE"
      }
    ],
    "kind": "ScalarField",
    "name": "storeFormattedDate",
    "storageKey": "storeFormattedDate(style:\"WEEKDAY_AND_DATE\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetCalendarOverviewContentPaginatedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WidgetCalendarOverviewContent_widget"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetCalendarOverviewContentPaginatedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "connectedCalendars",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "includeExternal",
                    "value": true
                  }
                ],
                "concreteType": "StoreCalendar",
                "kind": "LinkedField",
                "name": "calendars",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": "calendars(includeExternal:true)"
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "StoreCalendarTeamCalendarEventsConnection",
                "kind": "LinkedField",
                "name": "calendarEvents",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreCalendarTeamCalendarEventsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CalendarEvent",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoreZonedDate",
                            "kind": "LinkedField",
                            "name": "startAt",
                            "plural": false,
                            "selections": (v6/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoreZonedDate",
                            "kind": "LinkedField",
                            "name": "endAt",
                            "plural": false,
                            "selections": (v6/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoreZonedDate",
                            "kind": "LinkedField",
                            "name": "createdAt",
                            "plural": false,
                            "selections": (v6/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isAllDayEvent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoreCalendar",
                            "kind": "LinkedField",
                            "name": "storeCalendar",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "color",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "startAtDateAndTime",
                            "args": null,
                            "concreteType": "StoreZonedDate",
                            "kind": "LinkedField",
                            "name": "startAt",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": "endAtDateAndTime",
                            "args": null,
                            "concreteType": "StoreZonedDate",
                            "kind": "LinkedField",
                            "name": "endAt",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": "startAtWeekdayAndDate",
                            "args": null,
                            "concreteType": "StoreZonedDate",
                            "kind": "LinkedField",
                            "name": "startAt",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": "endAtWeekdayAndDate",
                            "args": null,
                            "concreteType": "StoreZonedDate",
                            "kind": "LinkedField",
                            "name": "endAt",
                            "plural": false,
                            "selections": (v8/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": "endAtTime",
                            "args": null,
                            "concreteType": "StoreZonedDate",
                            "kind": "LinkedField",
                            "name": "endAt",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "style",
                                    "value": "TIME_ONLY"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "storeFormattedDate",
                                "storageKey": "storeFormattedDate(style:\"TIME_ONLY\")"
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "WidgetCalendarOverviewContent__calendarEvents",
                "kind": "LinkedHandle",
                "name": "calendarEvents"
              }
            ],
            "type": "WidgetCalendarOverview",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "430d95d52a2517c87854e04026d9e4ef",
    "id": null,
    "metadata": {},
    "name": "WidgetCalendarOverviewContentPaginatedQuery",
    "operationKind": "query",
    "text": "query WidgetCalendarOverviewContentPaginatedQuery(\n  $after: String\n  $first: Int\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...WidgetCalendarOverviewContent_widget\n    id\n  }\n}\n\nfragment CalendarOverviewEventItemDateTime_event on CalendarEvent {\n  startAtDateAndTime: startAt {\n    isoString\n    ...StoreFormattedDate_2LP8ap\n  }\n  endAtDateAndTime: endAt {\n    isoString\n    ...StoreFormattedDate_2LP8ap\n  }\n  startAtWeekdayAndDate: startAt {\n    ...StoreFormattedDate_1hpjGt\n  }\n  endAtWeekdayAndDate: endAt {\n    ...StoreFormattedDate_1hpjGt\n  }\n  endAtTime: endAt {\n    ...StoreFormattedDate_1b2lNL\n  }\n  isAllDayEvent\n}\n\nfragment StoreFormattedDate_1b2lNL on StoreZonedDate {\n  storeFormattedDate(style: TIME_ONLY)\n}\n\nfragment StoreFormattedDate_1hpjGt on StoreZonedDate {\n  storeFormattedDate(style: WEEKDAY_AND_DATE)\n}\n\nfragment StoreFormattedDate_2LP8ap on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment WidgetCalendarOverviewContent_widget on WidgetCalendarOverview {\n  connectedCalendars: calendars(includeExternal: true) {\n    id\n  }\n  calendarEvents(first: $first, after: $after) {\n    edges {\n      node {\n        id\n        startAt {\n          isoString\n        }\n        endAt {\n          isoString\n        }\n        createdAt {\n          isoString\n        }\n        isAllDayEvent\n        ...WidgetCalendarOverviewEventItem_event\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment WidgetCalendarOverviewEventItem_event on CalendarEvent {\n  title\n  storeCalendar {\n    color\n    id\n  }\n  ...CalendarOverviewEventItemDateTime_event\n}\n"
  }
};
})();

(node as any).hash = "09f0caba87e84b2b15d0adc386fc9aa6";

export default node;
